// extracted by mini-css-extract-plugin
module.exports = {"selected":"selected-2d9Bj","lang_opened":"lang_opened-1OrtV","dropdown":"dropdown-3HXyP","icon":"icon-3bVJP"};